// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  margin: 0;

  padding: ${({ theme }) => theme.metrics.margin}px ${({ theme }) => theme.metrics.largeMargin}px;
  background-color: ${({ theme }) => theme.colors.cardBackground};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  font-size: ${({ theme }) => theme.fonts.style.midSmall.fontSize}px;
  color: ${({ theme }) => theme.colors.primaryText};
  margin-left: ${({ theme }) => theme.metrics.margin}px;
  font-weight: 500;
`;

const LinkText = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
  margin-left: ${({ theme }) => 2 * theme.metrics.largeMargin}px;
`;

const Icon = styled(LinkText)`
  margin-left: 0;
  font-weight: 900;
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
`;

const CloseIcon = styled.i`
  font-size: ${({ theme }) => theme.fonts.style.secondary.fontSize}px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BannerTypeRectangle = styled.div`
  width: ${({ theme }) => theme.metrics.notificationRectangle.width}px;
  height: ${({ theme }) => theme.metrics.notificationRectangle.height}px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  color: ${({ theme }) => theme.colors.tertiaryText};

  background-color: ${({ theme }) => theme.colors.primary};
`;

type Props = {
  onView?: () => any;
  onAction?: () => any;
  actionIcon?: string;
  t: (string) => any;
  theme: Object;
  title: string;
  bannerType: string;
};

class Banner extends React.Component<Props> {
  onAction = (event: Object) => {
    event.stopPropagation();

    if (this.props.onAction) {
      this.props.onAction();
    }
  }

  render() {
    const { t, theme, title, bannerType, actionIcon, onAction, onView } = this.props;

    return (
      <Wrapper className="row">
        <ContentWrapper className="col-lg-11 col-xs-11" onClick={this.props.onView}>
          <Column>
            <BannerTypeRectangle>{bannerType.toUpperCase()}</BannerTypeRectangle>
            <Text style={{ marginLeft: theme.metrics.margin }}>{title}</Text>
          </Column>
          <Column>
            {onView && <LinkText>{t('view')}</LinkText>}
            {onView && <Icon className="material-icons">keyboard_arrow_right</Icon>}
          </Column>
        </ContentWrapper>
        {onAction && actionIcon &&
          <ContentWrapper style={{ justifyContent: 'flex-end' }} className="col-lg-1 col-xs-1" onClick={this.onAction}>
            <CloseIcon className="material-icons">{actionIcon}</CloseIcon>
          </ContentWrapper>
        }
      </Wrapper>
    );
  }
}

export default translate('promotions')(withTheme(Banner));



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/components/Banner.js